'use strict';

var nearley = require('nearley');

var grammar = require('./../grammar');

var exceptions = require('./../exceptions');

var _ = require('lodash');

module.exports.parse = function (expression) {
  var result = void 0;

  try {
    result = createParser().feed(expression);
  } catch (error) {
    throw new exceptions.ParserException(error.message);
  }

  return result.results[0];
};
/**
    * Creates a new parser for our grammar. This must be done between each evaluation because nearley
    * works off of a stream model. So calling feed() multiple times on the same instance results in a continuation of
    * evaluation not a new evaluation
    * @return {NearleyParser} creates a new nearley parser
    */


function createParser() {
  return new nearley.Parser(grammar.ParserRules, grammar.ParserStart);
}

function formatExpression(expression, likelyVariables) {
  if (_.isEmpty(likelyVariables)) {
    return expression;
  } // Ordering variables from longest to shortest so that string replacement will occur in that order.
  // The assumption is that a tokenization from longest to shortest should produce the expected tokenized expression.


  var regexOps = _(likelyVariables).orderBy(function (varName) {
    return varName.length;
  }, 'desc').map(function (varName) {
    var escapedName = varName.replace(/\(|\)/g, '\\$&');
    return '(?:' + escapedName + ')';
  }).value().join('|');

  return expression.replace(new RegExp('(' + regexOps + ')', 'g'), '#{$&}');
}
/**
   * Given a pretty expression string, and a context, parse it into a proper expression
   * @param  {String} expression the expression to parse.
   * @param  {Object} context    an object containing keys with the variable values.
   * @return {Object}            [description]
   */


module.exports.parsePrettyString = function (expression, context) {
  var knownVariableNames = _.keys(context);

  return {
    parsedExpressionString: formatExpression(expression, knownVariableNames),
    variables: knownVariableNames
  };
};
/**
    * Given a formatted expression remove the tokenization
    * @param  {string} expression the expression to format
    * @return {string}            the prettified expression string
    */


module.exports.getPrettyString = function (expression) {
  return expression.replace(/(#{)(.*?)(})/g, '$2');
};